import { bl_fi_generic_doc_hdr_RowClass, bl_fi_generic_doc_line_RowClass, bl_fi_generic_doc_link_RowClass, bl_fi_pick_pack_queue_RowClass, bl_inv_current_company_stock_balance_RowClass, bl_inv_current_location_stock_balance_RowClass } from "../../../../dbschema";
import { BaseContainerModel } from "../../../base-container.model";

export class PickPackQueueContainerModel extends BaseContainerModel {
    bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowClass = new bl_fi_generic_doc_hdr_RowClass();
    bl_fi_generic_doc_hdrs_2: bl_fi_generic_doc_hdr_RowClass[] = [];
    bl_fi_generic_doc_lines: bl_fi_generic_doc_line_RowClass[] = [];
    bl_fi_generic_doc_links: bl_fi_generic_doc_link_RowClass[] = [];
    bl_fi_pick_pack_queues: bl_fi_pick_pack_queue_RowClass[] = [];
    bl_inv_current_location_stock_balances: bl_inv_current_location_stock_balance_RowClass[][] = [];
    bl_inv_current_company_stock_balances: bl_inv_current_company_stock_balance_RowClass[][] = [];
}